import { Button, DatePicker, Select, Tag } from "antd";
import { DeleteOutlined, EditOutlined, FileTextOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";
import dayjs from "dayjs";
import { date2locale, downloadFile } from "../common/common";
import { api } from "../common/api";
import TablePage from "../components/TablePage";

const inspectionColumns = [
  { title: "ID", ellipsis: true, dataIndex: "id", key: "id", width: 70 },
  {
    title: "Data",
    dataIndex: "date",
    ellipsis: true,
    key: "date",
    render: (date) => date && date2locale(date),
  },
  {
    title: "Esito",
    dataIndex: "outcome",
    ellipsis: true,
    key: "outcome",
    render: (outcome) => (
      <Tag variant={"outlined"} color={outcome ? "green" : "red"}>
        {outcome ? "Positivo" : "Negativo"}
      </Tag>
    ),
  },
  {
    title: "Scadenza",
    dataIndex: "dueDate",
    ellipsis: true,
    key: "dueDate",
    render: (date) => date && date2locale(date),
  },
  { title: "Note", dataIndex: "notes", key: "notes", ellipsis: true },
  {
    title: "Documento",
    key: "doc",
    ellipsis: true,
    render: (record) => (
      <Button
        icon={<FileTextOutlined />}
        size={"small"}
        onClick={() => downloadFile(`inspection/${record.id}/file`)}
      />
    ),
  },
];

const inspectionFilters = [
  {
    name: "date",
    label: "Data",
    readableValue: date2locale,
    formItem: {
      children: <DatePicker format="DD-MM-YYYY" style={{ width: "100%" }} />,
      props: {
        getValueProps: (value) => ({ value: value ? dayjs(value) : null }),
        normalize: (value) => value?.format("YYYY-MM-DD"),
      },
    },
  },
  {
    name: "outcome",
    label: "Esito",
    readableValue: (value) => (value === "true" ? "Positivo" : "Negativo"),
    formItem: {
      children: (
        <Select
          allowClear
          options={[
            { label: "Positivo", value: "true" },
            { label: "Negativo", value: "false" },
          ]}
        />
      ),
    },
  },
];

export default function Inspections({ showTitle = true, type, id }) {
  const navigate = useNavigate();
  const targetField = { VEHICLE: "vehicle", SETUP: "setup", EQUIPMENT: "equipment", DPI: "dpi" }[
    type
  ];

  return (
    <TablePage
      key={`${type}-${id}`}
      title={showTitle && "Revisioni"}
      columns={inspectionColumns}
      addPath={`newInspection?type=${type}&id=${id}`}
      addInTable
      actionsMenu={{
        items: (record) => [
          { key: "edit", icon: <EditOutlined />, label: "Modifica" },
          { key: "delete", icon: <DeleteOutlined />, label: "Elimina", danger: true },
        ],
        onClick: (key, record, refresh) => {
          if (key === "edit") navigate(`inspections/${record.id}/edit`);
          if (key === "delete") api.inspection.delete(Number(record.id)).then(refresh);
        },
      }}
      filterItems={inspectionFilters}
      enableSelection={false}
      fetchFunction={({ page, pageSize, date, outcome }) =>
        api.inspection.list({ [targetField]: id, type, page, pageSize, date, outcome })
      }
    />
  );
}
